export enum ChartViewTypes {
  DEVICE = "DEVICE",
  LANGUAGE = "LANGUAGE",
  MAILING = "MAILING",
}
